<template>
  <div class="user_info_container_content">
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>直播列表</span>
        <button v-if="listData.length > 0" class = "title_top_right_btn personal_add_btn rt" @click = "applyLive">发布直播</button>
        <el-divider></el-divider>
      </p>
    </div>
    <div class="personal_live_list_box"
    v-loading="listLoading"
    element-loading-text="列表加载中"
    element-loading-spinner="el-icon-loading">
      <div v-if="!listLoading && listData.length === 0" class="my_none">
      <img class="my_none_img" src="../../assets/img/user/liveListNone.png" alt="直播列表为空"><br/>
      <p class="my_none_user_text">
        <span>您暂且未发布任何直播！</span>
      </p>
      <button class = "personal_add_none_btn" @click.prevent = "applyLive">发布直播</button>
      </div>
      <div v-else>
        <div v-for="(item, index) in listData" :key="item.id" class="personal_live_list_item">
          <div class="personal_live_list_head">
            <p class="personal_live_list_title lf" @click="detail(item.llb_id, item.list_id)">
              {{item.room_title}}
            </p>
            <p class="personal_live_list_time rt">
              {{item.add_time}}
            </p>
          </div>
          <div class="personal_live_list_foot">
            <div class="personal_live_other lf">
              <span v-if="item.one_nav === '社区生态'" class="lf">{{item.one_nav}} - {{item.nav_name}}</span>
              <span v-else-if="item.union_name !== ''" class="lf">{{item.one_nav}} - {{item.union_name}} - {{item.nav_name}}</span>
              <span v-else-if="item.research_name !== ''" class="lf">{{item.one_nav}} - {{item.research_name}} - {{item.nav_name}}</span>
              <el-divider direction="vertical"></el-divider>
              <el-breadcrumb separator="·">
                <el-breadcrumb-item v-if="item.status === 4">报名数 {{item.count}}</el-breadcrumb-item>
                <el-breadcrumb-item v-if="item.status === 5">观看人数 {{item.on_count}}</el-breadcrumb-item>
                <el-breadcrumb-item v-if="item.status === 6">阅读量 {{item.browse}}</el-breadcrumb-item>
                <el-breadcrumb-item v-if="item.status === 6">评论 {{item.message}}</el-breadcrumb-item>
                <el-breadcrumb-item v-if="item.status === 6">收藏 {{item.count}}</el-breadcrumb-item>
                <el-breadcrumb-item v-if="item.status === 6">分享 {{item.share}}</el-breadcrumb-item>
                <el-breadcrumb-item v-if="item.status === 7">您已错过直播时间</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <div class="personal_live_btn rt">
              <div class="lf" v-if="item.status === 1">
                <span class="personal_live_btn_text" @click="rdialogOnOff.review = true">审核中</span>
                <el-dialog
                  title="提示"
                  :visible.sync="rdialogOnOff.review"
                  width="30%">
                  <span>直播内容正在审核中...</span>
                  <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="rdialogOnOff.review = false">确 定</el-button>
                  </span>
                </el-dialog>
              </div>
              <div class="lf" v-if="item.status === 4 && item.is_open === 0">
                <span class="personal_live_btn_text"  @click="rdialogOnOff.wait = true">等待直播</span>
                <el-dialog
                  title="温馨提示"
                  :visible.sync="rdialogOnOff.wait"
                  width="30%">
                  <i class="el-icon-warning"></i>
                  <span>未到直播时间，请您耐心等候...</span>
                  <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="rdialogOnOff.wait = false">确定</el-button>
                  </span>
                </el-dialog>
              </div>
              <div class="lf" v-if="item.status === 3">
                <span class="personal_live_btn_text"  @click="rdialogOnOff.refuse = true">审核拒绝</span>
                <el-dialog
                  title="温馨提示"
                  :visible.sync="rdialogOnOff.refuse"
                  width="30%">
                  <p>您的直播申请被拒绝</p>
                  <p>拒绝原因：{{item.reason}}</p>
                  <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="rdialogOnOff.refuse = false">确 定</el-button>
                  </span>
                </el-dialog>
              </div>
              <div class="lf" v-if="item.status === 4 && item.is_open === 1">
                <span class="personal_live_btn_text"  @click="openLive(item.list_id, item.nav_id, index)">我要开播</span>
                <el-dialog
                  title="温馨提示"
                  :visible.sync="rdialogOnOff.start && rdialogOnOff.startIndex === index"
                  :show-close = "false"
                  width="50%">
                  <div v-if="item.nav_id !== 15">
                    <p v-if="openLiveContent.length === 0"> <i class="el-icon-loading"></i> 正在获取推流地址...</p>
                    <p v-else>
                    您的推流地址：
                    服务：自定义，<br/>
                    服务器：{{openLiveContent[0]}}<br/>
                    串流密匙：{{openLiveContent[1]}}<br/>
                    </p>
                  </div>
                  <div v-else>
                    <p v-if="opendiscussListContent.length === 0"> <i class="el-icon-loading"></i> 正在获取推流地址...456</p>
                    <div v-else> 您的会议地址：
                    <br/>
                      <dl v-for="(i, index) in opendiscussListContent" :key="i.id" >
                        <dt>参会成员{{index + 1}}的直播地址：<br/>
                        推流：{{i.push_url}}</dt>
                        <dd>拉流：{{i.play_url}}
                        <el-divider></el-divider>
                        </dd>
                      </dl>
                    </div>
                  </div>
                  <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="rdialogOnOff.start = false">确定</el-button>
                  </span>
                </el-dialog>
              </div>
              <div class="lf" v-if="item.status === 5">
                <span class="personal_live_btn_text"  @click="rdialogOnOff.conduct = true">直播中</span>
                <el-dialog
                  title="温馨提示"
                  :visible.sync="rdialogOnOff.conduct"
                  width="30%">
                  <span>直播正在进行中</span>
                  <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="rdialogOnOff.conduct = false">确 定</el-button>
                  </span>
                </el-dialog>
              </div>
              <el-divider v-if="item.status === 5" direction="vertical" class="lf"></el-divider>
              <div class="lf" v-if="item.status === 5">
                <span class="personal_live_btn_text"  @click="rdialogOnOff.close = true, rdialogIndex = index">关闭直播</span>
                <el-dialog
                  title="温馨提示"
                  :visible.sync="rdialogOnOff.close && rdialogIndex === index"
                  width="30%">
                  <i class="el-icon-warning"></i>
                  <span>是否确定关闭当前直播：{{item.room_title}}</span>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="rdialogOnOff.close = false">取 消</el-button>
                    <el-button type="primary" @click="closeLive(item.list_id, index)">确定</el-button>
                  </span>
                </el-dialog>
              </div>
              <div class="lf" v-if="item.status === 6">
                <span class="personal_live_btn_text"  @click="rdialogOnOff.end = true, rdialogIndex = index">回放</span>
                <el-dialog
                  title="回放列表"
                  :visible.sync="rdialogOnOff.end && rdialogIndex === index"
                  :show-close = false
                  :center = true
                  width="50%">
                  <el-table v-if="item.video_list.length > 0" :data="item.video_list">
                    <el-table-column property="title" label="名称" min-width="200"></el-table-column>
                    <el-table-column :formatter="endStatus" label="状态" width="150"></el-table-column>
                    <el-table-column label="操作" width="200">
                      <template slot-scope="scope">
                        <button class="my_follow_btn" @click="jump(scope.row.list_id, scope.row.nav_id, scope.row.status)">查看</button>
                        <button v-if="scope.row.is_exhibition === 0" class="my_follow_btn" @click="closeVideo(scope.row.list_id, scope.row.is_exhibition, index, scope.$index)">隐藏回放</button>
                        <button v-else class="my_follow_btn" @click="closeVideo(scope.row.list_id, scope.row.is_exhibition, index, scope.$index)">显示回放</button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="rdialogOnOff.end = false">关闭</el-button>
                  </span>
                </el-dialog>
              </div>
              <div class="lf" v-if="item.status === 7">
                <!-- <span class="personal_live_btn_text">重新开播</span> -->
              </div>
              <!-- <el-divider direction="vertical"></el-divider> -->
              <!-- <span @click.stop="detail(index, item.id, $event)">查看</span> -->
              <!-- <span v-if="item.status === 1 || item.status === 3" @click.stop="detail(item.llb_id, item.list_id)">查看</span> -->
              <!-- <span v-if="item.status === 4 || item.status === 5 || item.status === 6" @click.stop="detail(item.llb_id, item.list_id)">查看</span> -->
              <!-- <el-divider direction="vertical" v-if="item.status === 3 || item.status === 4"></el-divider> -->
              <!-- <span v-if="item.status === 3 || item.status === 4" @click="edit(item.id)">编辑</span> -->
              <!-- <el-divider direction="vertical" v-if="item.status === 3 || item.status === 6"></el-divider> -->
              <!-- <span v-if="item.status === 3 || item.status === 6">删除</span> -->
            </div>
          </div>
        </div>
        <el-pagination
          v-if="listData.length > 0"
          background
          layout="prev, pager, next"
          :page-size= "listLimit"
          :total="listNum"
          @current-change = "pageChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 直播状态弹窗
      rdialogOnOff: {
        review: false, // 审核
        refuse: false, // 拒绝
        wait: false, // 等待
        start: false, // 开始
        startIndex: '', // 弹窗标记
        conduct: false, // 进行中
        close: false, // 关闭直播
        end: false // 结束
      },
      rdialogIndex: '',
      playbackList: [], // 回放列表
      listData: [], // 直播列表
      listNum: 0, // 直播总条目
      listLimit: 10, // 列表当前页显示条目数
      listPage: 1, // 列表当前页码
      liveDetail: {}, // 直播详情
      imgArray: [], // 直播详情图片列表
      listLoading: true, // 开启加载动画
      openLiveContent: [], // 开播地址
      opendiscussListContent: [] // 研讨沙龙开播地址
    }
  },
  created () {
    this.pageChange()
  },
  methods: {
    // 发布直播
    applyLive: function () {
      const vueThat = this
      const info = vueThat.$store.state.user.info
      // 验证是否通过播主认证
      if (info.is_authentication === 0) { // 未通过
        vueThat.myApi.isAnchor().then(res => { // 调用接口后台查询播主认证状态
          if (res.data.code === 200) {
            if (res.data.data.is_authentication === 0) { // 未认证，跳转认证页面
              vueThat.$alert('您还未进行播主认证！', '温馨提示', {
                showConfirmButton: true,
                iconClass: 'iconfont icon-jinggao',
                confirmButtonText: '去认证',
                callback: action => {
                  vueThat.$store.commit('editPersonalMeunAct', 'anchorCertification')
                  vueThat.$router.push({ path: '/anchorCertification' })
                }
              }).catch(function (erro) {
                console.log(erro)
              })
            } else { // 已验证修改localstore存储项，跳转发布页面
              info.is_authentication = res.data.data.is_authentication
              vueThat.$store.commit('user/updateUserInfo', info)
              vueThat.applyOnOff = false
              const routeData = vueThat.$router.resolve({
                path: '/liveApply'
              })
              window.open(routeData.href, '_blank')
            }
          }
        })
      } else {
        vueThat.applyOnOff = false
        const routeData = vueThat.$router.resolve({
          path: '/liveApply'
        })
        window.open(routeData.href, '_blank')
      }
    },
    // 我要开播
    openLive: function (id, navId, index) {
      console.log(navId)
      const vueThat = this
      if (navId !== 15) {
        vueThat.myApi.liveAdminOpenLive({ list_id: id }).then((res) => {
          vueThat.rdialogOnOff.start = true
          vueThat.rdialogOnOff.startIndex = index
          vueThat.openLiveContent = res.data.data
        })
      } else {
        vueThat.myApi.getDiscussPushList({ list_id: id }).then((res) => {
          vueThat.rdialogOnOff.start = true
          vueThat.rdialogOnOff.startIndex = index
          vueThat.opendiscussListContent = res.data.data
        })
      }
    },
    // 直播信息修改
    edit: function (id) {
      this.$router.push({ name: 'LiveApply', query: { id: id } })
    },
    // 关闭直播间
    closeLive (id, index) {
      const vueThat = this
      vueThat.myApi.downcast({ list_id: id }).then((res) => {
        if (res.data.code === 200) {
          vueThat.rdialogOnOff.close = false
          vueThat.listData[index].status = 6
        }
      })
    },
    // 状态判断
    endStatus (row) {
      let text = ''
      switch (row.status) {
        case 0:
          text = '回放生成中'
          break
        case 1:
          text = '回放生成成功'
          break
        case 2:
          text = '回放生成失败'
          break
      }
      return text
    },
    // 回放查看跳转
    jump (id, navId, status) {
      let url = ''
      console.log(navId)
      switch (navId) {
        case 100:
          url = '/receptionVideoDetail/:id'
          break
        case 101:
          url = '/discussVideoDetail/:id'
          break
      }
      const routeData = this.$router.resolve({
        path: url,
        query: { id: id }
      })
      window.open(routeData.href, '_blank')
    },
    // 关闭回放
    closeVideo (id, exhibition, i, n) {
      const vueThat = this
      let val = 0; let text = ''
      if (exhibition === 0) {
        val = 1
        text = '是否隐藏直播回放？'
      } else {
        val = 0
        text = '是否显示直播回放？'
      }
      vueThat.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        vueThat.myApi.editVideoExhibition({ list_id: id, exhibition: val }).then((res) => {
          if (res.data.code === 200) {
            vueThat.$message({
              type: 'success',
              message: '操作成功!'
            })
            vueThat.listData[i].video_list[n].is_exhibition = val
          }
        }).catch((res) => {
          vueThat.$message({
            type: 'error',
            message: '操作失败，请检查网络!'
          })
        })
      }).catch(() => {
      })
    },
    // 直播详情
    detail: function (llbId, listId) {
      const routeData = this.$router.resolve({
        path: '/receptionAnchorDetails/:liveId/:listId',
        query: { llbId: llbId, listId: listId }
      })
      window.open(routeData.href, '_blank')
    },
    // 切换页面
    pageChange: function (index) {
      const vueThat = this
      if (index === undefined) {
        vueThat.listPage = 1
      } else {
        vueThat.listPage = index
      }
      const data = {
        limit: vueThat.listLimit,
        page: vueThat.listPage
      }
      vueThat.myApi.liveAdminList(data).then(function (res) {
        if (res.data.code === 200) {
          vueThat.listLoading = false
          vueThat.listData = res.data.data.data
          vueThat.listNum = res.data.data.data_count
        }
      })
    }
  }
}
</script>

<style scoped="scoped">
  .personal_live_list_box{
    min-height: 500px;
  }
  .my_follow_btn{
    margin-right: 10px;
  }
</style>
